import BaseModal from './component.jsx'
import { ModalContentWrapper } from './component.styles'
export default BaseModal
export { ModalContentWrapper }
